import { EmailServiceConfiguration, MicroMClient } from '@mcurros2/microm';
import { APP_ID } from '../../../config';

export const CustomEmailConfigurationHelpText = "* Configuración para el envío de emails";

export class CustomEmailConfiguration extends EmailServiceConfiguration {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.Title = "Configuración de Email";
        this.HelpText = CustomEmailConfigurationHelpText;

        this.def.columns.i_smtp_port.prompt = "Puerto SMTP";
        this.def.columns.i_smtp_port.description = "Puerto de conexión al servidor SMTP";
        this.def.columns.bt_use_ssl.prompt = "Usar SSL";
        this.def.columns.bt_use_ssl.description = "Usar SSL para la conexión al servidor SMTP";
        this.def.columns.vc_smtp_host.prompt = "Servidor SMTP";
        this.def.columns.vc_smtp_host.description = "Dirección del servidor SMTP";
        this.def.columns.vc_user_name.prompt = "Usuario";
        this.def.columns.vc_user_name.description = "Usuario para autenticarse en el servidor SMTP";
        this.def.columns.vc_password.prompt = "Contraseña";
        this.def.columns.vc_password.description = "Contraseña para autenticarse en el servidor SMTP";
        this.def.columns.vc_default_sender_email.prompt = "Email de Remitente";
        this.def.columns.vc_default_sender_email.description = "Email del remitente por defecto";
        this.def.columns.vc_default_sender_name.prompt = "Nombre del Remitente";
        this.def.columns.vc_default_sender_name.description = "Nombre del remitente por defecto";

        this.def.columns.vc_template_subject.prompt = "Asunto";
        this.def.columns.vc_template_subject.description = "Asunto del email que se enviará";
        this.def.columns.vc_template_subject.defaultValue = "MTS - Recuperación de contraseña";
        this.def.columns.vc_template_subject.placeholder = "MTS - Recuperación de contraseña";

        this.def.columns.vc_template_body.prompt = "Mensaje";
        this.def.columns.vc_template_body.description = "Cuerpo del email que se enviará";
        this.def.columns.vc_template_body.defaultValue = 'Ha solicitado un email para recuperar su contraseña.\n\nPor favor siga este enlace para establecer su nueva contraseña https://<YOUR_SITE>/recover/?code={RECOVERY_CODE}\n\nMTS support team.';
        this.def.columns.vc_template_body.placeholder = this.def.columns.vc_template_body.defaultValue;

        this.def.columns.c_email_configuration_id.value = APP_ID;
    }
}